import request from '@/utils/request'

export function getList(params) {
  return request({
    url: '/tokenUsages/load',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/tokenUsages/add',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/tokenUsages/update',
    method: 'post',
    data
  })
}

export function del(data) {
  return request({
    url: '/tokenUsages/delete',
    method: 'post',
    data
  })
}

